import React, { useContext } from 'react';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../../../../changeCategoryPositionState/changeCategoryPositionContext';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { Item } from './components/Item';
import style from './DnDList.module.scss';

export const DnDList: React.FC = () => {
	const { setPositionsData, positionsData } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);

	const handleDragEnd = (result: DropResult) => {
		if (!positionsData || !result.destination) {
			return null;
		}
		const items = positionsData;
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		setPositionsData(items);
	};

	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<Droppable droppableId="categoriesList">
				{(provided) => (
					<div
						className={style.items}
						ref={provided.innerRef}
						{...provided.droppableProps}
						data-test="DnDList">
						{positionsData.map((item, index) => (
							<Draggable key={item.id} draggableId={item.id} index={index}>
								{(provided) => (
									<div ref={provided.innerRef} {...provided.draggableProps}>
										<Item
											data={item}
											positionNumber={index + 1}
											dragHandleProps={provided.dragHandleProps}
										/>
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};
